import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5374cc9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-cluster-popup-group" }
const _hoisted_2 = { class: "dw-cluster-popup-group__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Группа заказов", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.1406 1.827C13.141 1.827 13.1413 1.82735 13.1421 1.82807L14.1722 2.85843C14.173 2.85896 14.1731 2.85932 14.1733 2.85985C14.1734 2.86021 14.1734 2.86057 14.1733 2.86093C14.1733 2.86146 14.173 2.86182 14.1722 2.86253L9.03474 8.00003L14.1722 13.1375C14.173 13.1382 14.1731 13.1386 14.1733 13.1391C14.1734 13.1395 14.1734 13.14 14.1733 13.1404C14.1733 13.1407 14.173 13.1411 14.1722 13.1418L13.1419 14.172C13.1413 14.1727 13.141 14.1729 13.1406 14.1731C13.1402 14.1732 13.1398 14.1732 13.1394 14.1731C13.1388 14.1731 13.1385 14.1727 13.1378 14.172L8.00028 9.0345L2.86278 14.172C2.86206 14.1727 2.86171 14.1729 2.86117 14.1731C2.86076 14.1732 2.86033 14.1732 2.85992 14.1731C2.85956 14.1731 2.85921 14.1727 2.85849 14.172L1.82831 13.1416C1.8276 13.1411 1.82742 13.1407 1.82724 13.1404C1.82712 13.14 1.82712 13.1395 1.82724 13.1391C1.82724 13.1386 1.8276 13.1382 1.82831 13.1375L6.96581 8.00003L1.82831 2.86253C1.8276 2.86182 1.82742 2.86146 1.82724 2.86093C1.82712 2.86052 1.82712 2.86008 1.82724 2.85968C1.82724 2.85932 1.8276 2.85896 1.82831 2.85825L2.85867 1.82807C2.85921 1.82735 2.85956 1.82718 2.85992 1.827C2.86033 1.82687 2.86076 1.82687 2.86117 1.827C2.86171 1.827 2.86206 1.82735 2.86278 1.82807L8.00028 6.96557L13.1378 1.82807C13.1385 1.82735 13.1388 1.82718 13.1394 1.827C13.1398 1.82687 13.1402 1.82687 13.1406 1.827Z",
  fill: "black",
  "fill-opacity": "0.45"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "dw-cluster-popup-group__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_cluster_popup_group_feature = _resolveComponent("dw-cluster-popup-group-feature")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(), _createElementBlock("svg", {
        class: "header__close",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
      }, _hoisted_5))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, i) => {
        return (_openBlock(), _createBlock(_component_dw_cluster_popup_group_feature, {
          key: feature.id,
          feature: feature,
          "is-courier-item": _ctx.isCourierItem,
          onClick: ($event: any) => (_ctx.onSelect(feature, i))
        }, null, 8, ["feature", "is-courier-item", "onClick"]))
      }), 128))
    ])
  ]))
}